import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Sidebar, { MobileNav } from "./components/Sidebar";
import AuthGate from "./components/AuthGate";
import CampaignPage from "./pages/CampaignPage";
import InvoicesPage from "./pages/InvoicesPage";
import CashflowPage from "./pages/CashflowPage";
import RemittancePage from "./pages/RemittancePage";
import { GLASS_CSS } from "./shared";

export default function App() {
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = GLASS_CSS;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <AuthGate>
    <BrowserRouter>
      <div
        style={{
          display: "flex",
          height: "100vh",
          padding: "12px",
          gap: "12px",
          boxSizing: "border-box",
          background: "linear-gradient(160deg, #ececf0 0%, #e8e8ed 45%, #ebebf0 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background orbs — give backdrop-filter something to blur */}
        <div style={{ position: "fixed", width: 400, height: 400, borderRadius: "50%", top: -110, left: -90, background: "radial-gradient(circle, rgba(200,200,212,0.92) 0%, transparent 65%)", pointerEvents: "none", zIndex: 0 }} />
        <div style={{ position: "fixed", width: 460, height: 460, borderRadius: "50%", bottom: -140, right: -100, background: "radial-gradient(circle, rgba(188,194,212,0.88) 0%, transparent 65%)", pointerEvents: "none", zIndex: 0 }} />
        <div style={{ position: "fixed", width: 320, height: 320, borderRadius: "50%", top: "38%", left: "44%", background: "radial-gradient(circle, rgba(215,215,226,0.72) 0%, transparent 65%)", pointerEvents: "none", zIndex: 0 }} />
        <div style={{ position: "fixed", width: 240, height: 240, borderRadius: "50%", top: "6%", right: "14%", background: "radial-gradient(circle, rgba(204,206,222,0.78) 0%, transparent 65%)", pointerEvents: "none", zIndex: 0 }} />

        {/* Desktop sidebar */}
        <div className="sidebar-desktop" style={{ display: "flex", height: "100%", position: "relative", zIndex: 10, flexShrink: 0 }}>
          <Sidebar />
        </div>

        {/* Main content */}
        <main
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            position: "relative",
            zIndex: 1,
          }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/campaigns" replace />} />
            <Route path="/campaigns" element={<CampaignPage />} />
            <Route path="/invoices"  element={<InvoicesPage />} />
            <Route path="/cashflow"     element={<CashflowPage />} />
            <Route path="/remittances"  element={<RemittancePage />} />
          </Routes>
        </main>

        {/* Mobile bottom nav */}
        <MobileNav />
      </div>
    </BrowserRouter>
    </AuthGate>
  );
}
